<svelte:options customElement="hb-faq-component" />

<script lang="ts">
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type { Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",
    // style,
    info = undefined,
    topics = undefined,
    filter = undefined,
  }: Component = $props();
  //  let componentStyleToSet: string = "";

  $effect(() => {
    // if (style) {
    // }
    if (typeof info === "string") {
      try {
        info = JSON.parse(info);
      } catch (err) {
        console.error("error parsing info", err);
      }
    }
    if (typeof topics === "string") {
      try {
        topics = JSON.parse(topics);
        let i = 0;
        if (topics?.length)
          topics = topics.map((m) => {
            m.index = i;
            i++;
            return m;
          });
      } catch (err) {
        console.error("error parsing topics", err);
      }
    }
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div id="topics" class="hb-faq-topics is-flex is-flex-wrap-wrap">
  {#each Array.isArray(topics) ? topics : [] as t (t.index)}
    {#if t.index && t.index % 5 === 0}
      <div class="break" aria-hidden="true"></div>
    {/if}
    <button
      type="button"
      class="button is-light hb-faq-topic"
      onclick={() => {
        if (t.catchAll) filter = undefined;
        else filter = t.key;
      }}
    >
      <i class="bi bi-{t.icon}"></i>
      {t.label}
    </button>
  {/each}
</div>
{#if Array.isArray(info)}
  <div class="hb-faq-list">
    {#each info.filter( (f) => (filter ? f.topic === filter : true), ) as i (i.title)}
      <div class="hb-faq-item">
        <input
          id="q1_{i.title.replace(/ /g, '')}"
          type="checkbox"
          class="hb-faq-toggle"
        />
        <div class="hb-faq-plus" aria-hidden="true">+</div>
        <label for="q1_{i.title.replace(/ /g, '')}" class="hb-faq-question-label"
          >{i.title}</label
        >
        <div class="content hb-faq-answer">{@html i.text}</div>
      </div>
    {/each}
  </div>
{/if}

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
